import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserManagementRoutingModule } from './user-management-routing.module';
import { UserManagementComponent } from './user-management/user-management.component';
import { ViewUserComponent } from './view-user/view-user.component';
import { SharedModule } from '../../shared/shared.module';
import { UserMgmtService } from './user.service';
import { AddUserComponent } from './add-user/add-user.component';
import { RolesService } from '../roles/roles.service';
import { UserDashboardComponent } from './user-dashboard/user-dashboard.component';
import { GoogleChartsModule, ScriptLoaderService } from 'angular-google-charts';



@NgModule({
  declarations: [UserManagementComponent, ViewUserComponent, AddUserComponent,UserDashboardComponent],
  imports: [
    CommonModule,
    UserManagementRoutingModule,SharedModule,GoogleChartsModule
  ],
  providers:[UserMgmtService, RolesService ,ScriptLoaderService]
})
export class UserManagementModule { }
